// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_84hq5","foot_link":"index_foot_link_YPdDF","list":"index_list_1HvYl","link":"index_link_mNbH5","copyright":"index_copyright_dQitm"};